import { message } from "antd";
import socketIoClient from "socket.io-client"
import { socketsURL } from "../Environments/environment"
import { getFromLocalStorage } from "../Helpers/helpers";

const socketInstance = socketIoClient(socketsURL)


socketInstance.on('connect', function () {
    console.log('connected to realtime server...')
    if (window.rooms)
        window.rooms.map(room => {
            socketInstance.emit('join', room)
            console.log(room)
        })
});

const disconnect = () => {
    let currentLocal = getFromLocalStorage('current')
    let socketId = `${currentLocal?.line?.id}-stats`
    socketInstance.emit('leave', socketId)
    socketInstance.off(socketId)
}


export {
    socketInstance as socket,
    disconnect,
}